import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {
    UserSubscription,
    UserSubscriptionCategory,
    UserSubscriptionIds,
    UserSubscriptionType
} from '../../user/user-subscription';
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {PaymentDialogComponent} from "../billing/payment-dialog/payment-dialog.component";
import {PaymentMethod} from '../../user/payment-method';
import {GoogleAnalyticsService} from "../../shared/services/google-analytics/google-analytics.service";
import {IPlanDescriptionInstance} from "../../user/plan-description/plan-description";
import {Product} from "../../websites/website/product";
import {Location} from '@angular/common';
import {Config} from "../../config/config";
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {UserReferral} from "../../user/user-referral";
import {Store} from "@ngrx/store";
import * as fromStore from '../../store';
import {UserService} from "../../user/user.service";
import {User} from "../../user/user";
import {Utils} from "../../shared/utils/utils";
import {
    AccountUpgradedDialogComponent
} from "../../shared/components/dialogs/account-upgraded-dialog/account-upgraded-dialog.component";
import {TypeUtils} from "../../shared/utils/type-utils";
import {Subject} from "rxjs";
import {combineLatest} from "rxjs";
import {GlobalEvent} from "../../shared/services/global-event-dispatcher/global-event";
import {UserManagementService} from "../../user-managment/user-management.service";
import {
    GlobalEventDispatcherService
} from "../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {PlanInfoResolver} from "../../account/upgrade-plan/upgrade__plan-info";
import {NotifierComponent} from "../../shared/components/notifier/notifier.component";
import {Notification} from "../../shared/components/notifier/notification";
import {NotificationType} from "../../shared/components/notifier/notification-type";
import {Website} from "../../websites/website/website";
import {
    NotificationDialogComponent
} from "../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../shared/utils/text-utils";
import {AuthService} from "../../auth/auth.service";
import {DbResponse} from "../../shared/interceptors/db-response";

@Component({
    selector: 'db-upgrade-plan',
    templateUrl: './upgrade-plan.component.html',
    styleUrls: ['./upgrade-plan.component.scss'],
    standalone: false
})
export class UpgradePlanComponent implements OnInit, OnDestroy {

    public UserSubscriptionType = UserSubscriptionType;
    public UserSubscriptionCategory = UserSubscriptionCategory;
    public userSubscriptionIds = UserSubscriptionIds;

    private _subscriptions: Subscription[];

    private _userSubscriptions: UserSubscription[];
    public currentSubscription: UserSubscription;
    public builderSubscription: UserSubscription;
    public upgradeablePersonalSubscription: UserSubscription;
    public upgradeableSpecialPersonalSubscription: UserSubscription;
    public upgradeablePremiumSubscription: UserSubscription;
    public upgradeableEnterpriseSubscription: UserSubscription;
    public paymentMethods: PaymentMethod[];
    public currentWorkspace: any;

    public upgradeBasicSubscription: UserSubscription;
    public newSubscription: UserSubscription;
    public upgradeStandardSubscription: UserSubscription;
    public upgradeAdvancedSubscription: UserSubscription;
    public upgradeSingleSubscription: UserSubscription;
    public basicPlanDescriptionInstance: IPlanDescriptionInstance;
    public standardPlanDescriptionInstance: IPlanDescriptionInstance;
    public advancedPlanDescriptionInstance: IPlanDescriptionInstance;
    public singlePlanDescriptionInstance: IPlanDescriptionInstance;
    public currentPlanDescriptionInstance: IPlanDescriptionInstance;

    public activeTab: FormControl;
    public product: Product;
    public pluginSlug: string;
    public pluginTitle: string;
    public serviceTitle: string;
    public periodSwitch: FormControl;
    public tabsAvailable: boolean = true;
    public subscriptionId: any;
    public isPublishedSinglePlugin: boolean;
    public showDetails: boolean = true;
    public userRefferalSubsciption: UserReferral;
    public twCareLink: string = 'https://help.10web.io/hc/en-us/requests/new';
    public user: User;

    public upgradeablePlusSubscription: UserSubscription;
    public upgradeableFreelancerSubscription: UserSubscription;
    public upgradeableExpertSubscription: UserSubscription;
    public upgradeableUnlimitedSubscription: UserSubscription;

    public userLocalStorage: any;
    public showPercentPlatformOffer: boolean = false;
    public applyCouponForPlatform: boolean = false;
    public couponCode: string = '';
    public couponPercent: number = 0;
    public anniversaryLeftHours: number = 0;
    public anniversaryLeftMinutes: number = 0;
    public trialDeleteDay: string | number;
    public _trialDeleteDay: string | number;
    private showOnValue: string | number = 3800;
    public activeTabPlanTitle: string;
    public xDown: any = null;
    public yDown: any = null;
    public isMobile: boolean = false;
    public smallSize: boolean = false;
    public freeOffer: boolean = false;
    public planTypeInfo: any[];
    public tabIds: any = [];
    public subscriptions: any = [];
    public invitedUser: boolean;
    public aiBuilder1: any = [
        TextUtils.getText("text_upgradeToAiBuilderOpt1"),
        TextUtils.getText("text_upgradeToAiBuilderOpt2"),
        TextUtils.getText("text_upgradeToAiBuilderOpt3")
    ];
    public aiBuilder2: any = [
        TextUtils.getText("text_upgradeToAiBuilderOpt4"),
        TextUtils.getText("text_templates"),
        TextUtils.getText("text_ai-builder-responsive-design")
    ];

    @Input() addOwnWorkspace: any;
    private _destroyStream$: Subject<boolean> = new Subject<boolean>();
    private currentWorkspaceId: number;
    private ownerWorkspaceId: any;
    public loading: boolean;
    public hostedWebsites: Website[];
    public websites: Website[];
    public connectedWebsites: Website[];
    public newBuilderPlanId: any = 317;
    public toggled: boolean = false;
    public disablePeriodSwitch: boolean = false;
    public demoUser: boolean;

    public isNewPrice = false;

    constructor(
        private _router: Router,
        private _location: Location,
        private _route: ActivatedRoute,
        private _googleAnalyticsService: GoogleAnalyticsService,
        private _dialogService: DialogService,
        private _store: Store<fromStore.DbStoreState>,
        private _userService: UserService,
        private _userManagementService: UserManagementService,
        private _globalEventDispatcher: GlobalEventDispatcherService,
        private _authService: AuthService,
    ) {
        this._store.select(fromStore.getWebsitesLoaded)
            .pipe(
                filter((websitesLoaded: boolean) => websitesLoaded),
                switchMap(() => this._store.select(fromStore.getWebsites)),
                takeUntil(this._destroyStream$)
            )
            .subscribe((websites: Website[]) => {
                this.websites = websites.filter((website: Website) => !website.isNetwork && website.isActive && !website.isLocalhost && !website.isStopped);
                this.connectedWebsites = websites.filter((website: Website) => !website.isNetwork && website.isActive && !website.isLocalhost && !website.domain_hash && !website.isStopped);
                this.hostedWebsites = websites.filter((website: Website) => website.type === 'live' && website.isActive && !website.isLocalhost && website.domain_hash && !website.isStopped);
            });
    }

    public ngOnInit(): void {
        this.user = this._route.snapshot.data['user'];
        this.demoUser = Utils.isDemoUser(this.currentSubscription, this.user);

        /* if (this.addOwnWorkspace) {
           this.switchWorkspace(false);
         } */
        this.periodSwitch = new FormControl(this.currentSubscription?.type === 'starter' ? 12 : this.currentSubscription?.type !== 'platform' && !(this.currentSubscription?.plan.periodNumber === 1 || this.currentSubscription?.plan.periodNumber === 12) ? 1 : this.currentSubscription?.plan.periodNumber);

        this._store.select(fromStore.getUserLoaded)
            .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => combineLatest(
                    this._store.select(fromStore.getUserSubscription),
                    this._store.select(fromStore.getUserAvailableSubscriptions('platform')),
                    this._store.select(fromStore.getCurrentWorkspace),
                    this._store.select(fromStore.getUserAvailableSubscription(this.newBuilderPlanId, true)),
                    this._store.select(fromStore.getUserLocalStorage),
                    this._store.select(fromStore.getOwnerWorkspace)
                )),
                takeUntil(this._destroyStream$)
            )
            .subscribe(([userSubscription, userAvailableSubscriptions, currentWorkspace, builderSubscription, userLocalStorage, ownerWorkspace]) => {
                this._userSubscriptions = userAvailableSubscriptions;
                this.currentSubscription = userSubscription;
                this.currentWorkspace = currentWorkspace;
                this.builderSubscription = builderSubscription;
                this.userLocalStorage = userLocalStorage;

                this.paymentMethods = this._route.snapshot.data['paymentMethods'];

                // Check if there are any available plans, if not redirect to home
                if (!userAvailableSubscriptions || userAvailableSubscriptions.length === 0) {
                    console.log('[UpgradePlanComponent] No available subscriptions, redirecting to /');
                    this._router.navigate(['/']);
                }
            });
    }


    ngOnDestroy(): void {
        this._destroyStream$.next(true);
        this._destroyStream$.complete();
        this.removeEventHandlers();
    }

    public removeEventHandlers(): void {
        if (this._subscriptions && this._subscriptions.length) {
            this._subscriptions.forEach((subscription: Subscription): void => {
                subscription.unsubscribe();
            });
            this._subscriptions = null;
        }
    }
}
